import {Injectable} from '@angular/core';

export interface TIncomingMessage {
  eid?: number;
  header: string;
  details?: string;
  timestamp?: number;
  shortname?: string;
  serialnumber?: string;
  status?: string;
  sound?: string;
  popup?: boolean;
}

interface IInternalMessage extends TIncomingMessage {
  id: number;
  eid?: number;
  isExpanded?: boolean;
}

@Injectable()
export class HeaderNotificationsService {
  private nextId = 0;
  private _messages: IInternalMessage[] = [    /*{
    /!*id: 1,
    eid: 25431,
    header: '005SNWTestEvent20241122_205353_PCNUM05critical',
    details: '25431|26-11-2024 06:19:00-0300|005SNWTestEvent20241122_205353_PCNUM05critical|005SNWTestCalcParam20241122_211011_OWNTYPEмгн_CONTROLLER_005SNWTESTCONTRL20241122215145|0|1855|005SNWTestObject20241122_215015|005SNWTestParamStates20241122_205603_Критическое__forPCNUM05|005SNWTestIconParamState20241122214351|005SNWTestSENSORLOCATION20241122_214955|...|TestSE (ТЕСТОВЫЙ КОНТРОЛЛЕР)-не удалять|',
    timestamp: new Date().getTime(),
    shortname: '005SNWTestObject20241122_215015',
    serialnumber: '005SNWTESTCONTRL20241122215145',
    status: 'critical',
    sound: '1'*!/
  }*/
  ];

  constructor() {

  }


  get messages(): IInternalMessage[] {
    return this._messages;
  }

  public addMessage(message: TIncomingMessage): void {
    this.nextId++;
    this._messages.push(Object.assign({}, message, {id: this.nextId}));
  }

  public clear(): void {
    this._messages.length = 0;
  }

  public deleteMessageById(id: number): void {
    const index = this._messages.findIndex(message => +id === +message.id);
    if (index >= 0) {
      this._messages.splice(index, 1);
    }

  }

  public deleteMessageByEId(eid: number): void {
    const index = this._messages.findIndex(message => +eid === +message.eid);
    if (index >= 0) {
      this._messages.splice(index, 1);
    }
  }

}
